<nav class="navbar navbar-light startbg bg-secondary bg-lg shadow-lg p-3 mb-5">
    <div class="container text-white">
        <div class=" mt-5 text-center">
            <h1>O Argus</h1>
            <p class="mt-4">O Argus é uma solução para Call Center completa que oferece diversas ferramentas para garantir e proporcionar excelentes resultados em sua central de atendimento.</p>
          </div> 
         <div class="row">
       <div class="col-sm">
             <div class="card bg-transparent" style="width: 18rem;">
                 <img src="../../assets/monitoramento.svg" style="width: 18rem;" height="173">
                 <div class="card-body">
                   <h5 class="card-title text-center">Monitoramento</h5>
                   <ul>
                     <li>Gravações online</li>
                     <li>Visualizar tela operador</li>
                     <li>Monitoramento de prestadoras de telefonia</li>
                     &nbsp;
                   </ul>
                 </div>
               </div>
           </div>
           <div class="col-sm">
            <div class="card bg-transparent" style="width: 18rem;">
                <img src="../../assets/gestao.svg" style="width: 18rem;" height="173">
                <div class="card-body">
                  <h5 class="card-title text-center">Gestão</h5>
                  <ul>
                    <li>Pausas</li>
                    <li>Horário</li>
                    <li>Renitência</li>
                    <li>Tentativas</li>
                    &nbsp;
                  </ul>
                </div>
              </div>
           </div>
      <div class="col-sm">
            <div class="card bg-transparent" style="width: 18rem;">
                <img src="../../assets/discador.svg" style="width: 18rem;" height="173">
                <div class="card-body">
                  <h5 class="card-title text-center">Discador</h5>
                  <ul>
                    <li>Preditivo</li>
                    <li>Receptivo</li>
                    <li>Hibrido</li>
                    <li>URA</li>
                    &nbsp;
                  </ul>
                </div>
              </div>
           
          </div>
          
         </div>
<!--Segundo espaço-->
<div class="row">
  <div class="col-sm"><br><br>
        <div class="card bg-transparent" style="width: 18rem;">
            <img src="../../assets/marketing.svg" style="width: 18rem;" height="173">
            <div class="card-body">
              <h5 class="card-title text-center">Campanhas</h5>
              <ul>
                <li>Importação de Leads via API</li>
                <li>Distribuição de Leads Personalizado</li>
                &nbsp;&nbsp;&nbsp;<br><br>
                &nbsp;
              </ul>
            </div>
          </div>
       
      </div>
      <div class="col-sm"><br><br>
       <div class="card bg-transparent" style="width: 18rem;">
           <img src="../../assets/relatorio.svg" style="width: 18rem;" height="173">
           <div class="card-body">
             <h5 class="card-title text-center">Relatórios</h5>
             <ul>
               <li>Bilhetagem conta de telefonia</li>
               <li>Relatórios personalizáveis</li>
               <li>Desempenho do operador/discador/operação</li>
            
               &nbsp;
               &nbsp;
             </ul>
           </div>
         </div>
      
     </div>

     <div class="col-sm"><br><br>
       <div class="card bg-transparent" style="width: 18rem;">
           <img src="../../assets/grupos.svg" style="width: 18rem;" height="173">
           <div class="card-body">
             <h5 class="card-title text-center">Grupos Multiskill</h5>
             <ul>
               <li>Discagem</li>
               <li>Distribuição&nbsp;&nbsp;&nbsp;</li>
               <li>Parametrização operacional<br><br><br></li>
               &nbsp;
               &nbsp;
               &nbsp;
             </ul>
           </div>
         </div>
      
     </div>
     
    
     
    </div>


    </div>
   
 </nav>
 
 